<div class="modal-header bg-tertiary">
  <h6 class="modal-title fw-bold" id="editModalLabel"><i class="bi bi-pen me-2"></i>Apply a regularization</h6>
  <button type="button" class="btn-close" (click)="close()"></button>
</div>

<form [formGroup]="form" (ngSubmit)="submit()">
  <div class="modal-body">
    <div class="mb-3 position-relative">
      <label for="discountAmount" class="form-label small fw-bold">Amount ({{ billingRequest.paymentCurrency?.isoCode }})</label>
      <div class="input-group">
        <input type="number" class="form-control" id="discountAmount" placeholder="0" formControlName="amount" required>
        <span class="input-group-text"><i class="bi bi-currency-euro"></i></span>
      </div>
    </div>

    <div class="mb-5">
      <label for="reason" class="form-label small fw-bold">Reason</label>
      <div class="input-group">
        <span class="input-group-text"><i class="bi bi-pencil-square"></i></span>
        <select class="form-select" formControlName="category" id="reason">
          @for (billingLineCategory of billingLineCategoryList; track billingLineCategory) {
            <option
              [value]="billingLineCategory">
              {{ 'billingLineCategory.' + billingLineCategory | translate }}
            </option>
          }
        </select>
      </div>
    </div>

    <table class="table">
      <tbody>
        <tr>
          <td>Invoice</td>
          <td>
            @if (billingRequest.invoice && billingRequest.invoice.reference) {
              <code>{{ billingRequest.invoice.reference }}</code>
            }
            @if (!billingRequest.invoice || !billingRequest.invoice.reference) {
              <code>Deferred</code>
            }
          </td>
        </tr>
        <tr>
          <td>Amount after update</td>
          <td><code>{{ getFormattedAmount() }}</code></td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="modal-footer border-0">
    <button [disabled]="form.invalid || !form.value.amount" type="submit" class="btn btn-primary fw-bold">Update</button>
  </div>
</form>
